import { render, staticRenderFns } from "./InfoMessageEl.vue?vue&type=template&id=264b4866&scoped=true&"
import script from "./InfoMessageEl.vue?vue&type=script&lang=ts&"
export * from "./InfoMessageEl.vue?vue&type=script&lang=ts&"
import style0 from "./InfoMessageEl.vue?vue&type=style&index=0&id=264b4866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b4866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
